/*global VeloxGridController, moment, VeloxWebView*/

var renewController = new VeloxGridController("reseller_settings", {
    directory: "views/reseller",
    name: "renewGrid",
    route: "renew",
    joinFetch : [
        { otherTable: "reseller" },
        { otherTable: "velox_user", thisField: "r_code", otherField: "login", name: "user"}
    ] 
});

renewController.createSearch = function(){
    return {r_renew_status: {ope: "<>", value: null}} ;
} ;

renewController.searchRecords = function(callback){
    VeloxGridController.prototype.searchRecords.call(this, function(err, results){
        if(err){ return callback(err) ;}
        results = results.filter(function(r){
            return r.reseller && r.reseller.r_lang === this.routeData ;
        }.bind(this));
        callback(null, results) ;
    }.bind(this));
} ;

renewController.onAcceptRenew = function(ev){
    this.view.longTask(function(done){
        this.api.api.transactionalChanges([
            {
                table: "reseller_settings",
                record: {
                    r_code: ev.data.data.r_code, 
                    r_renew_status: 'ACCEPT', 
                }
            },
            {
                table: "reseller",
                record: {
                    r_code: ev.data.data.r_code, 
                    r_renew_date: new Date(),
                    r_date_end: moment(ev.data.data.reseller.r_date_end).add(1, 'year').toDate()
                }
            }
        ], function(err){
            if(err){ return done(err) ;}
            done() ;
            this.view.info(VeloxWebView.tr("renew.renewDone"), function(){
                this.refresh() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this));
} ;

renewController.onRefuseRenew = function(ev){
    this.view.longTask(function(done){
        this.api.api.transactionalChanges([
            {
                table: "reseller_settings",
                record: {
                    r_code: ev.data.data.r_code, 
                    r_renew_status: 'REFUSED', 
                }
            }
        ], function(err){
            if(err){ return done(err) ;}
            done() ;
            this.view.info(VeloxWebView.tr("renew.renewRefused"), function(){
                this.refresh() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this));
} ;



module.exports = renewController ;